export enum EKnAuctionCompaniesActionTypes {
  GetUsersAuctionSuccess = 'kn_auction_companies/get_users_auction_success',
}

export type IKnAuctionCompaniesState = Array<number>;
